<template>
    <v-form>

        <v-card-title>
            <v-spacer></v-spacer>
            <div :style="{
                width: '200px',
                position: 'absolute',
                right: '20px',
                top: '5px',
                textAlign: 'right'
            }">
                <v-tooltip
                    bottom
                    :max-width="300">
                    <template v-slot:activator="{ on }">
                        <v-btn
                            icon
                            v-on="on"
                            type="button"
                            class="mt-3"
                            :disabled="isRefreshing"
                            @click="onRefresh"
                        >
                            <v-progress-circular
                                v-if="isRefreshing"
                                indeterminate
                               >
                            </v-progress-circular>
                            <v-icon v-else>mdi-refresh-circle</v-icon>
                        </v-btn>
                    </template>
                    <span>This button will refresh company and location.</span>
                </v-tooltip>
            </div>
        </v-card-title>

        <v-container fluid>

            <v-row>
                <v-col cols="12" lg="4">
                    <v-switch
                        v-model="company.status"
                        :label="`Enable Company Mapping`"
                        color="primary"
                        style="display: inline-block; width: auto;"
                        dense>
                    </v-switch>
                </v-col>
            </v-row>
            <v-row class="ml-5">
                <v-col cols="12" lg="3">
                    <v-select
                        class="ml-2"
                        label="Map Type"
                        dense
                        v-model="company.map_type"
                        :items="mapTypes"
                        @change="company.map_value=''"
                        hide-details
                    ></v-select>
                </v-col>
                <v-col cols="12" lg="3">
                    <v-combobox
                        v-if="isCompanyMapField"
                        v-model="company.map_value"
                        :label="isCompanyMapField ? 'Select Company': 'Custom Company ID Field'"
                        :items="companies"
                        :return-object="false"
                        dense
                        hide-details
                        clearable
                    ></v-combobox>
                    <v-text-field
                        v-else
                        v-model="company.map_value"
                        class="ml-2"
                        :label="isCompanyMapField ? 'Select Company': 'Custom Company ID Field'"
                        dense
                        hide-details
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-row class="ml-5">
                <v-col cols="12" lg="7">
                    <FieldMapper
                        v-if="!isLoading && !isCompanyMapField"
                        ref="companyFieldMapper"
                        toLabel="Company"
                        :integration_id="id"
                        :items="company.mapping"
                        :toValueOptions="companies" />
                </v-col>
            </v-row>

            <v-row class="mt-5">
                <v-col cols="12" lg="4">
                    <v-switch
                        v-model="companyLocation.status"
                        :label="`Enable  Location Mapping`"
                        color="primary"
                        style="display: inline-block; width: auto;"
                        dense>
                    </v-switch>
                </v-col>
            </v-row>
            <v-row class="ml-5">
                <v-col cols="12" lg="3">
                    <v-select
                        class="ml-2"
                        label="Map Type"
                        dense
                        v-model="companyLocation.map_type"
                        :items="mapTypes"
                        @change="companyLocation.map_value=''"
                        hide-details
                    ></v-select>
                </v-col>
                <v-col cols="12" lg="3">
                    <v-combobox
                        v-if="isCompanyLocationMapField"
                        v-model="companyLocation.map_value"
                        :label="isCompanyLocationMapField ? 'Select Company Location': 'Custom Company Location ID Field'"
                        :items="companyLocations"
                        :return-object="false"
                        dense
                        hide-details
                        clearable
                    ></v-combobox>
                    <v-text-field
                        v-else
                        v-model="companyLocation.map_value"
                        class="ml-2"
                        :label="isCompanyLocationMapField ? 'Select Company Location': 'Custom Company Location ID Field'"
                        dense
                        hide-details
                    ></v-text-field>
                </v-col>
            </v-row>
            <v-row class="ml-5">
                <v-col cols="12" lg="7">
                    <FieldMapper
                        v-if="!isLoading && !isCompanyLocationMapField"
                        ref="companyLocationFieldMapper"
                        toLabel="Company Location"
                        :integration_id="id"
                        :items="companyLocation.mapping"
                        :toValueOptions="companyLocations" />
                </v-col>
            </v-row>

            <v-row>
                <div class="mt-5 text-right">
                    <v-btn small color="primary" @click="saveMapping">
                        <span v-if="isSaving">
                            <v-progress-circular
                                indeterminate
                                size="12"
                                width="2"
                                color="primary darken-3">
                            </v-progress-circular>
                            Saving..
                        </span>
                        <span v-else>Save Mapping</span>
                    </v-btn>
                </div>
            </v-row>
        </v-container>
    </v-form>
</template>

<script>
import { EventBus } from '@/js/event-bus.js'
import FieldMapper from './FieldMapper';
export default {
    props: {
        id: { type: Number },
    },
    components: {
        FieldMapper
    },
    data() {
        return {
            isLoading: true,
            isRefreshing: false,
            isSaving: false,
            companies: [],
            companyLocations: [],

            company: {

                field: 'companyId', //machship field
                map_type: '',
                map_value: '',
                status: false,
                mapping: [] // valueLookUps
            },

            companyLocation: {
                field: 'fromCompanyLocationId', //machship field
                map_type: '',
                map_value: '',
                status: false,
                mapping: [] // valueLookUps
            },

            mapTypes: [
                { value: 'direct', text: 'Direct' },
                { value: 'lookup', text: 'Lookup' }
            ]

        };
    },
    created() {
        this.fetchCompanyLocationMapping();
        this.fetchCompanies();
        this.fetchCompanyLocations();
    },

    computed: {
        isCompanyMapField() {
            return this.company.map_type === 'direct';
        },
        isCompanyLocationMapField() {
            return this.companyLocation.map_type === 'direct';
        }
    },

    methods: {
        // on refresh carrier and services
        async onRefresh() {
            try {
                await this.$http.post('/api/machship/refresh', { integration_id : this.id })
                EventBus.$emit('show-success', "Successfully refresh company and location")
            } catch (err) {
                EventBus.$emit('show-error', err)
            }
            this.isRefreshing = false
        },

        async fetchCompanies() {
            this.isLoadingCompanies = true;
            try {
                let res = await this.$http.get('/api/machship/companies', {
                    params: { integration_id: this.id },
                })

                if (!res || !res.status ) {
                    console.log("[COMPANY] unable to get company result", res)
                    return;
                }

                const { result } = res.data

                if (!result) {
                    console.warn("Unable to fetch companies of " + this.id)
                    return
                }

                this.companies = result.map(company => {
                    return {
                        value: String(company.id),
                        text: `[${company.id}] ` + company.name
                    }
                })

            } catch (error) {
                EventBus.$emit('show-error', "Unable to fetch companies of " + this.id)
                console.log("[COMPANY] error", error);
                this.companies = []
            }
        },

        async fetchCompanyLocations() {
            try {

                let res = await this.$http.get(`/api/machship/company-locations`, {
                    params: { integration_id: this.id },
                })

                if (!res || !res.status ) {
                    console.log("[COMPANY_LOCATION] unable to get company locations", res)
                    return;
                }

                const { result } = res.data

                if (!result) {
                    console.warn("Unable to fetch company locations of " + this.id)
                    return
                }

                this.companyLocations = result.map(location => {
                    return {
                        value: String(location.id),
                        text: `[${location.id}] ` + location.name + ' - ' + location.location.suburb + ', ' + location.location.postcode
                    }
                })


            } catch (error) {
                EventBus.$emit('show-error', "Unable to fetch company locations of " + this.company.name)
                console.log("[COMPANY_LOCATION] error", error);
                this.companyLocations = []
            }
        },

        fetchCompanyLocationMapping() {
            this.isLoading = true;
            this.$http.get(`/api/live-rates/settings/company-location-mapping/${this.id}`)
            .then(response => {
                if (response.data) {
                    this.company = response.data.data.company;
                    this.companyLocation = response.data.data.companyLocation;
                }
            })
            .catch(error => {
                EventBus.$emit('show-error', "Unable to fetch company location mapping");
                console.log("[COMPANY_LOCATION_MAPPING] error", error);
            })
            .finally(() => {
                this.isLoading = false;
            });
        },

        saveMapping() {
            this.isSaving = true;

            this.company.mapping = [];
            if(!this.isCompanyMapField){
                this.company.mapping = this.$refs.companyFieldMapper.items;
            }

            this.companyLocation.mapping = [];
            if(!this.isCompanyLocationMapField){
                this.companyLocation.mapping = this.$refs.companyLocationFieldMapper.items;
            }

            const data = {
                company: this.company,
                companyLocation: this.companyLocation
            };

            this.$http.post(`/api/live-rates/settings/company-location-mapping/${this.id}`, data)
            .then(response => {
                EventBus.$emit('show-success', "Mapping saved successfully");
                this.company = response.data.data.company;
                this.companyLocation = response.data.data.companyLocation;
                this.isSaving = false;
            })
            .catch(error => {
                EventBus.$emit('show-error', "Failed to save mapping: " + error.message);
                this.isSaving = false;
            });
        }
    }
};
</script>